<template>
  <transition name="modal">
    <div class="modal-mask" @click="onModalClick">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-close-wrapper" @click="onClose" >
            <Close class="modal-close" />
          </div>
          <div class="modal-header">
            <h1 class="appointment-title">Appointment details</h1>
          </div>
          <div class="modal-body">
            <div class="client-info">
              <div class="client-logo">
                <div class="client-logo__circle"  v-bind:style="{backgroundColor: clientColor}">
                  <div class="client-logo__initials">{{clientInitials}}</div>
                </div>
              </div>
              <div class="client-data">
                <div class="client-data__name">
                  <span class="client-data__name-value">{{appointment.client.first_name}} {{appointment.client.last_name}}</span>
                </div>
                <div class="client-data__contact">
                  <div class="client-data__email">
                    {{appointment.client.email}}
                  </div>
                  <div class="client-data__number">
                    {{formattedPhoneNumber}}
                  </div>
                </div>

              </div>
            </div>
            <div class="appointment-info">
              <div class="appointment-info__wrapper">
                <div class="appointment-info__title">APPOINTMENT TIME</div>
                <div class="appointment-info__value">
                  {{startTime}}
                </div>
              </div>
              <div class="appointment-info__wrapper">
                <div class="appointment-info__title">APPOINTMENT TYPE</div>
                <div class="appointment-info__value">
                  {{appointment.type_info.name}}
                </div>
              </div>
              <div class="appointment-info__wrapper">
                <div class="appointment-info__title">REASON</div>
                <div class="appointment-info__value">{{appointment.description}}</div>
              </div>
              <div class="appointment-info__wrapper">
                <div class="appointment-info__title">NOTES</div>
                <div class="appointment-info__value">{{appointment.notes}}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="modal-footer__left">
              <div class="otto-btn otto-btn--primary" @click="onChange"><span class="otto-btn-copy">Change</span></div>
            </div>
            <div class="modal-footer__right">
              <div class="otto-btn otto-btn--cancel" @click="onCancel"><span class="otto-btn-copy">Cancel</span></div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from 'moment-timezone';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { ADD_TOAST_MESSAGE } from 'vuex-toast';
import { UNSELECT_APPOINTMENT } from '@/store/mutation-types';
import Close from './Cancel.svg';

export default {
  name: 'Appointment',
  props: ['appointment'],
  components: {
    Close,
  },
  data() {
    return {};
  },
  mounted() {
    this.$el.querySelector('.modal-container').style.maxHeight = '85vh';
  },
  methods: {
    ...mapMutations({
      closeAppointment: UNSELECT_APPOINTMENT,
    }),
    ...mapActions([
      'deleteAppointment',
      'openEditMode',
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE,
    }),
    onChange() {
      this.openEditMode(this.appointment);
      this.closeAppointment();
    },
    onCancel() {
      this.showDeletePopup();
    },
    onModalConfirm() {
      this.$modal.hide('dialog');
      this.deleteAppointment(this.appointment)
        .then(() => {
          this.addToast({
            text: 'Successfully deleted appointment.',
            type: 'success',
          });
          this.closeAppointment();
        })
        .catch((err) => {
          this.addToast({
            text: err.message,
            type: 'danger',
          });
        });
    },
    onModalClick(e) {
      if (!e.target.classList.contains('modal-wrapper')) {
        return false;
      }
      this.closeAppointment();
      return true;
    },
    onClose() {
      this.closeAppointment();
    },
    showDeletePopup() {
      this.$modal.show('dialog', {
        text: 'Are you sure you want to cancel the appointment?',
        buttons: [{
          title: 'No',
        }, {
          title: 'Yes',
          default: true,
          handler: this.onModalConfirm,
        }],
      });
    },
  },
  computed: {
    ...mapGetters(['currentTimezone']),
    formattedPhoneNumber() {
      if (!this.appointment.client.phone_number) {
        return '';
      }
      let output;
      const input = this.appointment.client.phone_number.replace(/[^0-9]/g, '');
      const area = input.substr(0, 3);
      const pre = input.substr(3, 3);
      const tel = input.substr(6, 4);
      if (area.length < 3) {
        output = `(${area})`;
      } else if (area.length === 3 && pre.length >= 0 && pre.length < 3) {
        output = `(${area})-${pre}`;
      } else if (area.length === 3 && pre.length === 3) {
        output = `(${area})-${pre}-${tel}`;
      }

      return output;
    },
    startTime() {
      return moment.tz(this.appointment.start, this.currentTimezone).format('LLLL');
    },
    clientInitials() {
      const firstName = this.appointment.client.first_name;
      const lastName = this.appointment.client.last_name;
      return `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
    },
    clientColor() {
      const { client } = this.appointment;
      const r = client.display_color_r;
      const g = client.display_color_g;
      const b = client.display_color_b;
      return `rgb(${r}, ${g}, ${b})`;
    },
  },
};
</script>

<style src="@/assets/styles/appointment.sass" lang="sass"></style>



// WEBPACK FOOTER //
// src/components/Appointment.vue